import { useFeatureToggleContext } from "@payfac/providers";

export const FEATURE_TOGGLES = {
  newRatePlanPage: "comission_v2_migrate",
  pendenciesPage: "pendencies_screen",
  transactionMetabaseScreen: "transaction_metabase_screen",
  indicatorsMetabaseScreen: "indicators_metabase_screen",
  terminalsMetabaseScreen: "terminals_metabase_screen",
  ratePartnersScreen: "rate_partners_screen",
  sellerListScreen: "seller_list_screen",
} as const;

export type FeatureToggleName = keyof typeof FEATURE_TOGGLES;

export const useFeatureToggle = (name: FeatureToggleName) => {
  const { isEnabled, isLoading } = useFeatureToggleContext();

  return {
    isEnabled: isEnabled(FEATURE_TOGGLES[name]),
    isLoading,
  };
};
